module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_hospital-d5d8c1ff942c6a231fcb0fbf117707d9.png";